import '.ep{font-size:1.125rem;}.ssr-plugin'
import '.e8{line-height:1.75rem;}.ssr-plugin'
import '.fw{text-decoration:none;}.ssr-plugin'
import '.fy{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ep e8"
    >
      {translations.privacySubtitle}{' '}
      <a className="fw fy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="fw fy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
